import { t, UUID, Money, DateTimeISO } from '../common.ts';
import { GameType } from './game.ts';

export const BetStatus = t.Union([
  t.Literal('placed'),
  t.Literal('settled'),
  t.Literal('cancelled'),
  t.Literal('void'),
  t.Literal('payout_cancelled'),
]);

export const BetTransactionView = t.Object(
  {
    id: UUID,
    memberId: UUID,
    providerId: UUID,
    gameId: t.Union([UUID, t.Null()]),
    roundId: t.String(),
    externalBetId: t.Union([t.String(), t.Null()]),
    externalTxId: t.Union([t.String(), t.Null()]),
    currency: t.String(),
    betAmount: Money,
    winAmount: Money,
    turnover: Money,
    status: BetStatus,
    betAt: DateTimeISO,
    settledAt: t.Union([DateTimeISO, t.Null()]),
    cancelledAt: t.Union([DateTimeISO, t.Null()]),
  },
  { $id: 'BetTransactionView' },
);

export const OutstandingBetView = t.Object(
  {
    id: UUID,
    memberId: UUID,
    providerId: UUID,
    roundId: t.String(),
    amount: Money,
    betAt: DateTimeISO,
  },
  { $id: 'OutstandingBetView' },
);

export const WinlossHourlyView = t.Object(
  {
    memberId: UUID,
    providerId: UUID,
    gameType: GameType,
    hourBucket: DateTimeISO,
    eventCount: t.Integer(),
    totalBet: Money,
    totalPayout: Money,
    totalCancelBet: Money,
    totalVoid: Money,
    turnoverSum: Money,
    totalWinloss: t.Integer(),
    lastProcessedAt: DateTimeISO,
  },
  { $id: 'WinlossHourlyView' },
);

export const BetLimitView = t.Object(
  {
    memberId: UUID,
    providerId: UUID,
    minBet: Money,
    maxBet: Money,
  },
  { $id: 'BetLimitView' },
);
